import Api from '../Api'
import store from '@/store/store'
import axios from 'axios'

function buildMultipartHeaders() {
    const headers = {
        'apikey': process.env.VUE_APP_RTEK8DSR,
        'paraphrase': process.env.VUE_APP_BJ7DC3S
    }

    if (store.state && store.state.token) {
        headers['Authorization'] = 'Bearer ' + store.state.token
    }

    return headers
}

export default {
    // READ ALL - Mes documents
    getAllDocuments() {
        return Api().get(`userdocument/getall/${store.state.user._id}`)
    },

    // CREATE - Ajouter un document (avec fichier)
    uploadDocument(documentData) {
        const formData = new FormData()
        formData.append('document', documentData.file)
        formData.append('userid', store.state.user._id)
        formData.append('type_document', documentData.type_document)

        const baseURL = process.env.VUE_APP_API_URL
        return axios.post(`${baseURL}userdocument/add/`, formData, { headers: buildMultipartHeaders() })
    },

    // UPDATE - Modifier un document
    updateDocument(id, documentData) {
        const formData = new FormData()
        formData.append('id', id)
        formData.append('userid', store.state.user._id)
        formData.append('type_document', documentData.type_document)

        if (documentData.file) {
            formData.append('document', documentData.file)
        }

        const baseURL = process.env.VUE_APP_API_URL
        return axios.put(`${baseURL}userdocument/update`, formData, { headers: buildMultipartHeaders() })
    },

    // DELETE - Supprimer un document
    deleteDocument(id) {
        return Api().post('userdocument/delete', { id })
    },

    // DOWNLOAD - Télécharger un document via l'API
    downloadDocument(id) {
        const baseURL = process.env.VUE_APP_API_URL
        return axios.get(`${baseURL}userdocument/download/${id}`, {
            headers: buildMultipartHeaders(),
            responseType: 'blob'
        })
    },

    /**
     * Télécharge un fichier depuis une URL (S3 ou local)
     * @param {string} url - URL du fichier à télécharger
     * @param {string} filename - Nom du fichier pour le téléchargement (ex: 'mon-document.pdf')
     * @returns {Promise<void>}
     *
     * Exemple :
     * downloadFile('https://mybucket.s3.amazonaws.com/file.pdf', 'mon-fichier.pdf')
     */
    async downloadFile(url, filename = 'document') {
        try {
            // Validation des paramètres
            if (!url || typeof url !== 'string') {
                throw new Error('URL invalide fournie');
            }

            // Afficher un indicateur de chargement si nécessaire
            console.log(`Téléchargement de : ${filename}`);

            // 1. Récupérer le fichier avec fetch
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include' // Inclure les cookies si nécessaire
            });

            // Vérifier le statut de la réponse
            if (!response.ok) {
                const errorMessage = {
                    401: 'Accès refusé - Authentification requise',
                    403: 'Accès refusé - Vous n\'avez pas les droits',
                    404: 'Fichier non trouvé',
                    500: 'Erreur serveur - Veuillez réessayer'
                };
                throw new Error(errorMessage[response.status] || `Erreur HTTP ${response.status}`);
            }

            // 2. Convertir la réponse en blob
            const blob = await response.blob();

            // Vérifier que le blob n'est pas vide
            if (blob.size === 0) {
                throw new Error('Le fichier est vide ou corrompu');
            }

            // 3. Créer une URL temporaire pour le blob
            const blobUrl = URL.createObjectURL(blob);

            // 4. Créer un lien de téléchargement dynamique
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename; // Définir le nom du fichier
            link.style.display = 'none'; // Masquer le lien

            // 5. Ajouter le lien au DOM et cliquer dessus
            document.body.appendChild(link);
            link.click();

            // 6. Nettoyer : supprimer le lien et libérer la mémoire
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);

            console.log(`${filename} téléchargé avec succès`);

        } catch (error) {
            // Gérer les erreurs
            console.error('Erreur lors du téléchargement :', error.message);

            // Vous pouvez afficher un toast ou une notification
            const errorMessages = {
                'Failed to fetch': 'Erreur réseau - Vérifiez votre connexion',
                'TypeError': 'Erreur réseau - Impossible d\'accéder au fichier',
                'URL invalide': 'L\'URL du fichier n\'est pas valide'
            };

            const userMessage = errorMessages[error.message] || error.message || 'Erreur lors du téléchargement du fichier';

            // Lancer une erreur pour que le composant puisse la gérer
            throw new Error(userMessage);
        }
    }
}
